import { getAlertType, getAlertTypeText } from './../../../View/Alert/Utilities/getAlertType';
export const getAlertTypeViewItems = (alert) => {
    const alertType = getAlertType(alert);
    const text = getAlertTypeText(alertType);
    return {
        name: 'Type',
        values: [text],
    };
};
